import { Slide } from "@jelly/lesson";

import { task as task02 } from "../../../../../task/course-05/lesson-29/task-02";

const task: Slide = {
  titleHtml: `This duct is then split into two ducts with cross-section and lengths mutually equal.<br>Each duct arrives in a different receiving room. The airspeed in the cross-section of<br>each duct and outlet needs to be lower than 2,3 m/s to respect the NR30 criteria in<br>the room. What could be the cross-section of each duct and  outlet to achieve the<br>NR30 target?`,
  description: "Select the correct answer(s).",
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "__task__",
        data: {
          id: task02.id,
        },
      },
    },
  },
};

export default task;
